import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=517f1e78&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=517f1e78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f1e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517f1e78')) {
      api.createRecord('517f1e78', component.options)
    } else {
      api.reload('517f1e78', component.options)
    }
    module.hot.accept("./ui-button.vue?vue&type=template&id=517f1e78&scoped=true", function () {
      api.rerender('517f1e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/button/ui-button.vue"
export default component.exports